import { Flex } from "@similarweb/ui-components/foundations";

import GradientButton from "../GradientButton/GradientButton";
import type { GradientButtonVariant } from "../GradientButton/types";
import GradientTextfield from "../GradientTextfield/GradientTextfield";

type AIAgentChatControlsProps = {
    className?: string;
    isInputLocked: boolean;
    isSubmitLocked?: boolean;
    isDisabled?: boolean;
    isFocused: boolean;
    text: string;
    placeholder: string;
    onSubmit: () => void;
    onChange: (value: string) => void;
};

const AIAgentChatControls = ({
    className,
    isInputLocked,
    isSubmitLocked,
    isDisabled,
    isFocused,
    text,
    placeholder,
    onSubmit,
    onChange,
}: AIAgentChatControlsProps) => {
    const getButtonVariant = (): GradientButtonVariant => {
        if (isDisabled) {
            return "disabled";
        }

        if (isSubmitLocked) {
            return "locked";
        }

        return "submit";
    };

    return (
        <Flex
            gap="16px"
            data-automation="ai-agent-chat-controls"
            className={className}
            alignItems="flex-end"
        >
            <GradientTextfield
                isLocked={isInputLocked}
                isDisabled={isDisabled}
                value={text}
                placeholder={placeholder}
                isFocused={isFocused}
                autoFocus
                onChange={onChange}
                onKeyDown={(event: React.KeyboardEvent<HTMLTextAreaElement>) => {
                    if (event.key === "Enter" && !isSubmitLocked && !isDisabled && !event.shiftKey) {
                        onSubmit();
                    }
                }}
            />
            <GradientButton
                variant={getButtonVariant()}
                disabled={isDisabled}
                onClick={onSubmit}
            />
        </Flex>
    );
};

export default AIAgentChatControls;
